import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { LoadingButton } from "@src/appV2/redesign/components/LoadingButton";
import {
  BottomSheet,
  BottomSheetIllustrationContent,
  Text,
  type UseModalState,
} from "@src/appV2/redesign/system/ui-components";

interface VideoValidationFailedBottomSheetProps {
  modalState: UseModalState;
  onSeeInstructions: () => void;
  onCannotUseTimeclock: () => void;
}

export function VideoValidationFailedBottomSheet(props: VideoValidationFailedBottomSheetProps) {
  const { modalState, onSeeInstructions, onCannotUseTimeclock } = props;

  return (
    <BottomSheet
      modalState={modalState}
      footer={
        <DialogFooter orientation="vertical">
          <LoadingButton
            fullWidth
            variant="contained"
            size="large"
            isLoading={false}
            onClick={onSeeInstructions}
          >
            See instructions and try again
          </LoadingButton>
          <Button fullWidth variant="outlined" size="large" onClick={onCannotUseTimeclock}>
            I cannot use the timeclock
          </Button>
        </DialogFooter>
      }
    >
      <BottomSheetIllustrationContent
        illustrationType="warning"
        title="Missing confirmation screen"
        description={
          <Text>
            We saw no confirmation screen showing that your punch was recorded in the time clock.{" "}
            <Text
              sx={{
                color: (theme) => theme.palette.error.main,
                display: "inline",
              }}
            >
              Please punch again and record.
            </Text>
          </Text>
        }
      />
    </BottomSheet>
  );
}
